<template>
    <div ref="scriptContainer"></div>
</template>

<script>
    export default {
        props: {
            scriptContent: {
                type: String,
                default: ""
            },
        },
        mounted() {
            let substring = "<script";
            if(this.scriptContent.startsWith(substring)){
                this.insertScript();
            }else{
                this.insertWrapperScript();
            }
        },
        methods: {
            insertScript: function () {
                let parser = new DOMParser();
                let scriptDoc = parser.parseFromString(this.scriptContent, 'text/html');
                let originalScript = scriptDoc.querySelector('script');

                let script = document.createElement('script');
                script.textContent = originalScript.textContent;

                // Copy all attributes from the original script tag to the new script tag
                for (let attr of originalScript.attributes) {
                    script.setAttribute(attr.name, attr.value);
                }

                this.$refs.scriptContainer.appendChild(script);
            },
            insertWrapperScript: function () {
                let script = document.createElement('script');
                script.textContent = this.scriptContent;
                this.$refs.scriptContainer.appendChild(script);
            }
        }
    }
</script>